// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_2UR","cls2":"PaperClaiming-cls2_mQR PaperClaiming-cls1_2UR"};